import type {Converter, ConverterArguments, YConverterKey} from '../types'
import {getBottomMarginInPx, getParentHeight, getTopMarginInPx, getTopRowsHeight} from '../utils'
import {convertWidthToPx} from './width'
import type {GridItemLayout} from '@wix/document-services-types'

const alignSelfToPx = (converterArguments: ConverterArguments) => {
    const {measurementsMapAPI, compRef, value} = converterArguments
    const {get} = measurementsMapAPI

    let y = 0

    const {alignSelf, margins} = value as GridItemLayout
    switch (alignSelf) {
        case 'center': {
            const parentHeight = getParentHeight(converterArguments)
            y = parentHeight / 2 - get.height(compRef) / 2
            y += getTopMarginInPx(converterArguments, convertWidthToPx, margins) / 2
            y -= getBottomMarginInPx(converterArguments, convertWidthToPx, margins) / 2
            break
        }
        case 'end': {
            const parentHeight = getParentHeight(converterArguments)
            y = parentHeight - get.height(compRef)
            y -= getBottomMarginInPx(converterArguments, convertWidthToPx, margins)
            break
        }
        case 'start':
        case 'stretch':
        default:
            y = getTopMarginInPx(converterArguments, convertWidthToPx, margins)
    }

    const topRowsHeight = getTopRowsHeight(converterArguments)
    y += topRowsHeight

    return y
}

export const convertYToPx: Record<YConverterKey, Converter> = {
    alignSelf: alignSelfToPx
}
